/**
 * Iniciais de um nome, para o avatar de fallback.
 *
 * Primeira letra do primeiro e do último nome; nome com uma única palavra rende
 * uma inicial só. Nome ausente ou em branco devolve string vazia — o `Avatar`
 * do ADS já tem placeholder próprio para esse caso, e um `?` inventado aqui
 * pareceria dado do backend.
 *
 * @param name - Nome completo do aluno, como veio do backend.
 * @returns As iniciais em caixa alta, ou `''`.
 *
 * @example
 * ```ts
 * getStudentInitials('Lucas Henrique Financi'); // 'LF'
 * getStudentInitials('Lucas');                  // 'L'
 * getStudentInitials(null);                     // ''
 * ```
 */
export function getStudentInitials(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';

  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';

  return `${first}${last}`.toUpperCase();
}
